import instance from "./instance";
const responseData = response => response.data;

export function getMenuBoard() {
    return instance.request({ url: "/cms/menu-board", method: "GET" }).then(responseData);
}

export function getMenuBoardSection(sectionId) {
    return instance
        .request({ url: `/cms/menu-board/section/${sectionId}`, method: "GET" })
        .then(responseData);
}

export function getMenuBoardCategoryProducts(categoryId) {
    return instance
        .request({ url: `/cms/menu-board/category-products/${categoryId}`, method: "GET" })
        .then(responseData);
}

export function editMenuBoardCategory(sectionId, category) {
    return instance.request({
        url: `/cms/menu-board/section/${sectionId}/category`,
        method: "PUT",
        data: category,
    });
}

export function reorder(productId, currentSortOrder, newSortOrder) {
    return instance
        .request({
            url: `/cms/menu-board/product/${productId}/reorder`,
            method: "PUT",
            data: {
                currentSortOrder,
                newSortOrder,
            },
        })
        .then(responseData);
}

export function addMenuBoardCategoryProduct(sectionId, productInfo) {
    return instance.request({
        url: `/cms/menu-board/section/${sectionId}/product`,
        method: "POST",
        data: productInfo,
    });
}

export function updateMenuBoardCategoryProduct(productId, productInfo) {
    return instance.request({
        url: `/cms/menu-board/product/${productId}`,
        method: "PUT",
        data: productInfo,
    });
}

export function deleteMenuBoardCategoryProduct(productId) {
    return instance.request({
        url: `/cms/menu-board/product/${productId}`,
        method: "DELETE",
    });
}

export function addFeatureAsset(sectionId, data) {
    const formData = new FormData();
    for (const property in data) {
        if (property === "image") {
            continue;
        }
        formData.append(property, data[property]);
    }

    if (data.image) {
        formData.append("image.image", data.image.image);
        formData.append("image[centerX]", data.image.centerX);
        formData.append("image[centerY]", data.image.centerY);
        formData.append("image[width]", data.image.width);
        formData.append("image[height]", data.image.height);
    }

    return instance
        .request({
            url: `/cms/menu-board/section/${sectionId}/feature-asset`,
            method: "POST",
            data: formData,
        })
        .then(responseData);
}

export function reorderAsset(assetId, currentSortOrder, newSortOrder) {
    return instance
        .request({
            url: `/cms/menu-board/feature-asset/${assetId}/reorder`,
            method: "PUT",
            data: {
                currentSortOrder,
                newSortOrder,
            },
        })
        .then(responseData);
}

export function deleteMenuBoardFeatureAsset(assetId) {
    return instance.request({
        url: `/cms/menu-board/feature-asset/${assetId}`,
        method: "DELETE",
    });
}

export function editMenuBoardDisclaimer(sectionId, disclaimer) {
    return instance.request({
        url: `/cms/menu-board/section/${sectionId}/disclaimer`,
        method: "PUT",
        data: disclaimer,
    });
}
